'use strict';


module Patersons {
    export interface PortfolioSnapshotScope extends ng.IScope {
        events: PortfolioSnapshotCtrl;
        accounts: Array<Account>;
        isLoading: boolean;
        isError: boolean;
        hasData: boolean;
        selectedAccount: Account;
        cachedAccounts: any[]


    }
    export class PortfolioSnapshotCtrl extends PortfolioBaseCtrl {
        q: ng.IQService;
        scope: Patersons.PortfolioSnapshotScope;
        portfolioService: Patersons.PortfolioService;
        reportService: Patersons.ReportService;
        morningStarService: Patersons.MorningStarService;
        static $inject = ['$scope', '$q', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'reportService', 'reportDownloadService', 'portfolioService', 'navigationService', 'morningStarService'];

        constructor($scope, $q, $log, $location, $window, $state, $stateParams, $http, $rootScope, reportService, reportDownloadService, portfolioService, navigationService, morningStarService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.q = $q;
            this.scope.events = this;
            this.portfolioService = portfolioService;
            this.reportService = reportService;
            this.scope.accounts = new Array<Account>();
            this.morningStarService = morningStarService;
            this.scope.cachedAccounts = [];

            this.load();
        }
        load() {
            this.scope.isLoading = true;
            this.portfolioService.getCombinedPortfolioData()
                .then((result) => {
                    this.scope.$apply(() => {
                        this.scope.accounts = result;
                        if (result[0]) {
                            console.log(this.scope.selectedAccount)
                            this.setSelectedAccount(result[0].accountId);
                            setTimeout(() => {
                                this.getPortfolioSnapshot();
                            }, 500);
                            
                        }
                    });
                })
                .catch((reason) => {
                    this.scope.$apply(() => {
                        this.scope.isLoading = false;
                    });
                });
        }
        setSelectedAccount(accountId: string) {
            console.info('Selected Account Id: ' + accountId);
            this.scope.hasData = false;
            this.scope.selectedAccount = this.scope.accounts.filter(a => a.accountId == accountId)[0];
        }
        getPortfolioSnapshot = function () {
            // if(this.scope.isLoading){
            //     return;
            // }
            this.scope.isError = false;
            this.scope.hasData = false;
            this.scope.isLoading = true;
            
            this.loadPortfolioSnapshot();

        }
        extractCodesFromReport(report) {
            let codes = [];
            if (report) {
                report.forEach((item) => {
                    codes.push({
                        securityCode: item.securityCode,
                        exchangeCode: item.exchange
                    })
                })
            }
            return codes;
        }
        loadPortfolioSnapshot() {

            if (this.scope.selectedAccount.accountType == "Standard") {


                let codes = [];
                let cashAccountsPromise = this.portfolioService.getCashAccounts(this.scope.selectedAccount.accountId);
                cashAccountsPromise.then((result) => {
                    codes = codes.concat(this.extractCodesFromReport(result));
                }, (error) => { // error handling

                });

                let highInterestCashPromise = this.portfolioService.getHighInterestCashAccounts(this.scope.selectedAccount.accountId);
                highInterestCashPromise.then((result) => {
                    codes = codes.concat(this.extractCodesFromReport(result));
                }, (error) => { // error handling

                });

                let termDepositPromise = this.portfolioService.getTermDeposits(this.scope.selectedAccount.accountId);
                termDepositPromise.then((result) => {
                    codes = codes.concat(this.extractCodesFromReport(result));
                }, (error) => { // error handling

                });

                let internationalSharesPromise = this.portfolioService.getInternationalSharesForHoldings(this.scope.selectedAccount);
                internationalSharesPromise.then((result) => {
                    codes = codes.concat(this.extractCodesFromReport(result));
                }, (error) => { // error handling

                });

                let sharesPromise = this.portfolioService.getShares(this.scope.selectedAccount.accountId);
                sharesPromise.then((result) => {
                    codes = codes.concat(this.extractCodesFromReport(result));

                }, (error) => { // error handling

                });
                
                let allPromises = this.q.all([
                    cashAccountsPromise,
                    highInterestCashPromise,
                    termDepositPromise,
                    internationalSharesPromise,
                    sharesPromise]);
                allPromises.then(() => {
                    this.loadMorningStarSnapshot(this.scope.selectedAccount.accountId, codes);
                });
            } else {
                this.reportService.getReport(ReportType.Valuation, this.scope.selectedAccount.accountId, new Date(), new Date())
                    .then((report: ValuationStatement) => {
                        let codes = [];
                        report.nonLoaSecurities.forEach(category => {
                            category.items.forEach(item => {
                                codes.push({
                                    securityCode: item.code,
                                    exchangeCode: item.exchangeCode
                                })
                            })

                        })
                        report.loaSecurities.forEach(category => {
                            category.items.forEach(item => {
                                codes.push({
                                    securityCode: item.code,
                                    exchangeCode: item.exchangeCode
                                })
                            })

                        })
                        report.nonLoaUnsettledDividends.items.forEach(unsettledDividend => {
                            codes.push({
                                securityCode: unsettledDividend.code,
                                exchangeCode: unsettledDividend.exchangeCode
                            })
                        })
                        report.loaUnsettledDividends.items.forEach(unsettledDividend => {
                            codes.push({
                                securityCode: unsettledDividend.code,
                                exchangeCode: unsettledDividend.exchangeCode
                            })
                        })
                        this.loadMorningStarSnapshot(this.scope.selectedAccount.accountId, codes);
                    },
                        (error) => {
                            // error handling
                            this.scope.isError = true;
                            this.scope.hasData = false;
                        })
            }
        }

        loadMorningStarSnapshot(accountId, data: { exchangeCode: string, securityCode: string }[]) {
            var tickers = []
            //need to filter out funds (holdingTypeId = 2)
            Promise.all(data.map((code) => {
                return new Promise(resolveTicker => {
                    this.morningStarService.getMorningStarDataForSecurityCode(code.exchangeCode, code.securityCode).then(res => {
                        if (res) {
                            if (res.holdingTypeId != 2) {
                                tickers.push(res.FundShareClassId)
                            }
                        }
                        resolveTicker()
                    })
                })
            })).then(() => {
                //load data here
                rootMorningstarPromise().then((promiseChain) => {

                    initComponent(
                        'component-portfolio-snapshot-container', 
                        'ecWatchList-container', 
                        'ec-watch-list', 
                        'ecWatchList'
                    ).then(() => {
                        var watchlistInstance = morningstar.asterix.instanceRegistry.get('ecWatchList');

                        watchlistInstance.setParameter('showActionBar', false);
                        watchlistInstance.setParameter('tickers', tickers);

                        this.scope.$apply(() => {
                            this.scope.isLoading = false;
                        });

                    });
                })
                //the watchlist component takes a few seconds to load the data.
                //if there is an event to hook into this will be much better however at present there are no events to hook into that the component exposes. 
                setTimeout(() => {
                    
                }, 4000);
            })
        }
    }
}